<template>
  <select v-model="selected_profile" @change="updateLmsProfile($event.target.value)">
    <option :value="null"></option>
    <option v-for="profile in lms_profiles" :key="profile.lms_profile_id" :value="profile.lms_profile_id">
      {{ profile.name }}
    </option>
  </select>
</template>

<script>

export default {
  props: ["field", "data"],
  async created() {

  },
  async beforeMount() {
    if (this.data && this.data.loc_id) {
      await this.init(this.data.loc_id);
    }
  },
  methods: {
    async init(loc_id) {
      var _this = this;
      await this.$axios.get(`/lms_profiles`, {
        params: {
          loc_id: loc_id
        }
      }).then(res => {
        _this.lms_profiles = res.data.response.dataset || [];
        if (this.data && this.data.lms_profile_id) {
          const match = _this.lms_profiles.find(p => p.lms_profile_id === this.data.lms_profile_id);
          this.updateLmsProfile(match ? this.data.lms_profile_id : null);
        }
        return true;
      }).catch(err => {
        return false;
      });
    },
    updateLmsProfile(profile_id) {
      this.selected_profile = profile_id || null;
      this.$emit("input", this.selected_profile ? Number(this.selected_profile) : null);
    },
  },
  computed: {},
  data() {
    return {
      cp_loc: null,
      lms_profiles: [],
      selected_profile: null,
    }
  }
}
</script>

<style lang="scss">
</style>